export default "__VITE_ASSET__BFKPvgdf__"